import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import { ATF_JOB_TYPE, CREATE_MANUAL_JOB_TITLE, DEADLINE_DATE_KEY, DISTRIBUTION_DATE_KEY, MINIMUM_THRESHOLD_KEY, USAGE_DATE_FROM_KEY, USAGE_DATE_TO_KEY } from "../../Consts";
import { LOOKUP_WORKSTATUS, UPDATE_WORKFLOW_VIEW_STATUS_FIELD_STATE_KEY } from "../../../repertoire/Consts";
import { getOpenDistributionsThunk, triggerManualJob, } from "../../../redux/thunks/HomeThunks";
import { IDistributionState } from "../../../redux/types/IDistributionState";
import TextDataInput from "../../../repertoire/components/textDataInput/TextDataInput";
import SizedDateDataInput from "../../../repertoire/components/dateDataInput/DateDataInput";
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";


export interface IICEATFJobParametersProps {
    triggerManualJob: typeof triggerManualJob;
    createNewJob: any;
    setManualJobParameters: (parameters: ITriggerManualJob) => void;
    getOpenDistributions: typeof getOpenDistributionsThunk;
    openDistributions?: IDistributionState[];
    lookupValues: ILookupDictionary;
    scheduledJobSet?: (value: boolean) => void;
    onError?: (error: string) => void;
}

interface IICEATFJobParametersState {
    distributionDate: string;
    deadlineDate: string;
    minimumThreshold: number;
    usageDateFrom: string;
    usageDateTo: string;
    distributionIDs: Array<number>;
    generalError: string;
    workStatuses: Array<string>;
    loading: boolean;
}

export class ICEATFJobParameters extends React.Component<
    IICEATFJobParametersProps,
    IICEATFJobParametersState
    > {
    constructor(props: IICEATFJobParametersProps) {
        super(props);
        this.state = {
            minimumThreshold: null,
            deadlineDate: '',
            distributionDate: '',
            usageDateFrom: '',
            usageDateTo: '',
            distributionIDs: [],
            generalError: "",
            workStatuses: [],
            loading: false
        };
    }
    onClick = () => {
        try {
            this.setState({loading:true});
            if (this.setParamsandTriggerJob()) {
                const { createNewJob,scheduledJobSet } = this.props
                scheduledJobSet(true);
                createNewJob();
            }
        } catch (err: any) {
            this.props.onError?.(err?.message || err?.toString() || "An error occurred");
        } finally {
            this.setState({loading:false});
        }

    }
    handleDeadlineDateChange = (value: string | number | boolean, fieldname: string) => {
        this.setState({
            deadlineDate: value as string
        })
    }
    handleDistributionDateChange = (value: string | number | boolean, fieldname: string) => {
        this.setState({
            distributionDate: value as string
        })
    }
    handleMinimumThresholdChange = (value: string | number | boolean, fieldname: string) => {
        this.setState({
            minimumThreshold: value as number
        })

    }
    handleUsageDateFromChange = (value: string | number | boolean, fieldname: string) => {
        this.setState({
            usageDateFrom: value as string
        })
    }
    handleUsageDateToChange = (value: string | number | boolean, fieldname: string) => {
        this.setState({
            usageDateTo: value as string
        })
    }

    getFilteredDistributions = () =>
        (this.props.openDistributions || []).filter(d => d.distributionPools.length > 0);

    handleOptionChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        const { distributionIDs } = this.state;
        const allIDs = this.getFilteredDistributions().map(d => d.distributionID);

        if (option.key === "All") {
            this.setState({ distributionIDs: distributionIDs.length === allIDs.length ? [] : [...allIDs] });
        }
        else if (option.selected) {
            this.setState({ distributionIDs: [...distributionIDs, option.data] });
        }
        else {
            this.setState({ distributionIDs: distributionIDs.filter(id => id !== option.data) });
        }
    };
    renderOpenDistributions = (): IDropdownOption[] => {
        const distributionsOptions: IDropdownOption[] = this.getFilteredDistributions().map(val => ({
            data: val.distributionID,
            text: val.distributionCode + ' - ' + val.description,
            key: val.distributionID.toString()
        }));

        distributionsOptions.unshift({ key: "All", text: "All", data: "*" });
        return distributionsOptions;
    }
    setStatuses = (newStatuses: string[]) => {
        this.setState({ workStatuses: newStatuses });
    };
    getMultiSelectOptions = (lookupType: string) => {
        const { lookupValues } = this.props;
        if (!lookupValues || !lookupValues[lookupType]) {
            console.warn(`lookupValues or ${lookupType} is undefined`);
            return [];
        }
        var lookups = lookupValues[lookupType].lookups.filter((x) => x.code !== "NULL" && x.code !== null);

        const options = [];
        
        if (lookups) {
            lookups.map((c) => options.push({
                data: c.code,
                text: c.description,
                key: c.code
            }));
            options.sort((a, b) => a.text.localeCompare(b.text));
        }
        options.unshift({ key: "All", text: "All", data: "*" });
        return options;
    }

    componentDidMount() {
        const {
            getOpenDistributions,
            openDistributions,
        } = this.props;

        if (!openDistributions || openDistributions.length === 0) getOpenDistributions();
    }
    
    getFieldError = (): string => {
        const { minimumThreshold, usageDateFrom, usageDateTo } = this.state;

        if (minimumThreshold && isNaN(Number(minimumThreshold)))
            return "Minimum Threshold must be a number";

        if (minimumThreshold && Number(minimumThreshold) < 0)
            return "Minimum Threshold must be greater than or equal to zero";

        if (usageDateFrom && usageDateTo && new Date(usageDateFrom) > new Date(usageDateTo))
            return "Usage Date from cannot be after Usage Date to";

        return "";
    };

    setParamsandTriggerJob = () => {
        const { setManualJobParameters, triggerManualJob } = this.props;
        const { distributionDate, deadlineDate, minimumThreshold, usageDateFrom, usageDateTo, distributionIDs, workStatuses } = this.state;

        const fieldError = this.getFieldError();
        if (fieldError) {
            this.setState({ generalError: fieldError });
            return false;
        }

        if (this.validateFields()) {
            const manualJobParameters: ITriggerManualJob = {
                jobType: ATF_JOB_TYPE,
                jobParameters: JSON.stringify({ distributionIDs, distributionDate, deadlineDate, minimumThreshold, usageDateFrom, usageDateTo, workStatuses }),
            };

            setManualJobParameters(manualJobParameters);
            this.setState({ generalError: "" });
            return triggerManualJob(manualJobParameters)
        } else {
            this.setState({ generalError: "Please fill in all the required fields" });
            return false;
        }
    }

    validateFields = () => {
        const { distributionDate, deadlineDate, minimumThreshold, usageDateFrom, usageDateTo, distributionIDs, workStatuses } = this.state;
        return (!minimumThreshold || !distributionDate || !deadlineDate || !usageDateFrom || !usageDateTo || distributionIDs.length === 0 || workStatuses.length == 0) ? false : true;
    };

    dismissAlert = () => {
        this.setState({ generalError: "" });
    };

    handleChangeMultiSelect = (lookupType: string, option?: IDropdownOption) => {
        const { workStatuses } = this.state;
        let newOptions = workStatuses;

        let allOptions = this.getMultiSelectOptions(lookupType).map(x => x.key);
        allOptions = allOptions.filter(x => x !== "All");
        if (option.key == "All") {
            if (newOptions.length == allOptions.length) {
                newOptions = [];
            }
            else {
                newOptions = [];
                newOptions.push(...allOptions);
            }
        }
        else if (option.selected) {
            newOptions.push(option.key.toString());
        }
        else {
            newOptions.splice(newOptions.indexOf(option.key.toString()), 1);
        }

        this.setStatuses([...newOptions]);
    };

    render() {
        const { minimumThreshold, distributionDate, deadlineDate, usageDateFrom, usageDateTo, generalError, distributionIDs, workStatuses } = this.state;

        return (
            <>
                {generalError && (
                    <div className="alert alert-danger alert-dismissible">
                        <span>{generalError}</span>
                        <button type="button" className="close" aria-label="Close" onClick={this.dismissAlert}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                <div className="fieldFlex">
               
                <div className="formPlace">
                    <label>Distributions</label>
                    <Dropdown
                        selectedKeys={distributionIDs.map(id => id.toString())}
                        options={this.renderOpenDistributions()}
                        multiSelect={true}
                        onChange={this.handleOptionChange}
                        placeholder={""}
                        disabled={false}
                        required={true}
                    />
                </div>

                <div className="formPlace">
                    <label>Work Status</label>
                    <Dropdown
                        selectedKeys={workStatuses}
                        options={this.getMultiSelectOptions(LOOKUP_WORKSTATUS)}
                        multiSelect={true}
                        onChange={(e, o, i) => this.handleChangeMultiSelect(LOOKUP_WORKSTATUS, o)}
                        placeholder={""}
                        disabled={false}
                    />
                </div>

                <div className="formPlace">
                    <TextDataInput
                        label={MINIMUM_THRESHOLD_KEY}
                        fieldName={MINIMUM_THRESHOLD_KEY}
                        changeData={this.handleMinimumThresholdChange}
                        value={minimumThreshold}
                        readOnly={false}
                        isHidden={false}
                        isMandatory={true}
                    />
                </div>
                <div className="flexRow">
                    <SizedDateDataInput
                        label={DISTRIBUTION_DATE_KEY}
                        fieldName={DISTRIBUTION_DATE_KEY}
                        value={distributionDate}
                        changeData={this.handleDistributionDateChange}
                        readOnly={false}
                        isHidden={false}
                        isMandatory={true}
                    />
                    <SizedDateDataInput
                        label={DEADLINE_DATE_KEY}
                        fieldName={DEADLINE_DATE_KEY}
                        value={deadlineDate}
                        changeData={this.handleDeadlineDateChange}
                        readOnly={false}
                        isHidden={false}
                        isMandatory={true}
                    />
                </div>
                <div className="flexRow">
                    <SizedDateDataInput
                        label={USAGE_DATE_FROM_KEY}
                        fieldName={USAGE_DATE_FROM_KEY}
                        value={usageDateFrom}
                        changeData={this.handleUsageDateFromChange}
                        readOnly={false}
                        isHidden={false}
                        isMandatory={true}
                    />
                    <SizedDateDataInput
                        label={USAGE_DATE_TO_KEY}
                        fieldName={USAGE_DATE_TO_KEY}
                        value={usageDateTo}
                        changeData={this.handleUsageDateToChange}
                        readOnly={false}
                        isHidden={false}
                        isMandatory={true}
                    />
                </div>
                </div>
                <div className="actionRow paddingRightLarge paddingLeftLarge">
                    <div className="actionLeft">
                        <ActionButton buttonText={"Cancel"} buttonAction={this.props.createNewJob} className={"button btn-defaultSecondary"}/>
                        </div>
                        <div className="actionRight">
                        <ActionButton
                            buttonText={CREATE_MANUAL_JOB_TITLE}
                            buttonAction={() => this.onClick()}
                            disabled={this.state.loading || !this.validateFields()}
                        />
                        </div>
                    </div>
            </>
        );
    }
}
export default ICEATFJobParameters;